import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



class LightFormulas extends React.Component{

  render(){
    return(
      <MuiThemeProvider>

        <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderColumn style = {{width: 450}}>Uses</TableHeaderColumn>
        <TableHeaderColumn>Formula</TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableRowColumn style = {{width: 420}}>Slit lens (dark fringes positions)</TableRowColumn>
        <TableRowColumn> <img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/1.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 420}}>Double-slit (dark fringes positions)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/2.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 420}}>Photon Energy</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/3.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 420}}>Speed of Light</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/4.png")} /></TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>


      </MuiThemeProvider>

    );
  }
}

export default LightFormulas;



// WEBPACK FOOTER //
// ./src/Physics/Light/LightFormulas.js